//============================
//# ilsysisync_invitem
//# Interfész szinkron számlatétel köztes tábla
//============================
import IfaceSync from "./IfaceSync";

export default interface IfaceSyncInvoiceItem extends IfaceSync {
    /** Szinkron számlafej (mlsysisync_invhead.szam) */
    head: number;
    /** Külső számlaszám */
    invNo: string | null;
    /** Belső szla. tétel azonosító */
    intItemId: number;
    /** Tétel megnevezés */
    itemName: string | null;
    /** Helyesbített számla külső számlaszáma */
    invRectify: string | null;
    /** Helyesbített számla áfa időszaka */
    rectVatDate: Date | null;
    /** Jóváírt számla külső számlaszáma */
    invStorno: string | null;
    /** Beszámított előlegszámla külső sorszáma */
    dpaymIncInvId: string | null;
    /** Beszámított előlegszámla külső bizonylatszám */
    dpaymIncInvNo: string | null;
    /** Áfakulcs külcső kód */
    tax: string | null;
    /** Egységár (HUF) */
    unitPrice: number | null;
    /** Egységár a számla pénznemében */
    currUnitPrice: number | null;
    /** Engedményes egységár (HUF) */
    discountPrice: number | null;
    /** Engedményes egységár a számla pénznemében */
    currDiscountPrice: number | null;
    /** Mennyiség */
    quantity: number | null;
    /** Külső menyiségi egység kód */
    unitType: string | null;
    /** Nettó (HUF) */
    netto: number | null;
    /** Bruttó (HUF) */
    total: number | null;
    /** Áfa (HUF) */
    vat: number | null;
    /** Nettó a számla pénznemében */
    currNetto: number | null;
    /** Bruttó a számla pénznemében */
    currTotal: number | null;
    /** Áfa a számla pénznemében */
    currVat: number | null;
    /** Elábé összeg */
    elabeAmount: number | null;
    /** Külső gj. azonosító */
    car: string | null;
    /** Külső gj. megrendelés azonosító */
    prcar: string | null;
    /** Külső készlet azonosító */
    stock: string | null;
    /** Egyéb cikk, szolgáltatás vagy cikk? */
    isParts: boolean;
    /** Cikk típus */
    partsType: string | null;
    /** Külső cikk azonosító */
    parts: string | null;
    /** Külső cikk azonosító */
    gparts: string | null;
    /** Költséghely külső kód */
    accGroupCode: string | null;
    /** Tartozik oldal főkönyvi szám */
    accCodeT: string | null;
    /** Követel oldal főkönyvi szám */
    accCodeK: string | null;
    /** Elábé költséghely külső kód */
    expAccGroupCode: string | null;
    /** Tartozik oldal elábé főkönyvi szám */
    expAccCodeT: string | null;
    /** Követel oldal elábé főkönyvi szám */
    expAccCodeK: string | null;
    /** Tartozik oldal áfa főkönyvi szám */
    vatAccCodeT: string | null;
    /** Követel oldal áfa főkönyvi szám */
    vatAccCodeK: string | null;
    /** Áfaszámítás módjának külső kódja */
    vatCalcTypeCode: string | null;
    /** Üzletkönyvelési csoport */
    busPostGroup: string | null;
    /** Termékkönvelési csoport */
    prodPostGroup: string | null;
    /** Üzletkönyvelési csoport */
    vatBusPostGroup: string | null;
    /** Termékkönvelési csoport */
    vatProdPostGroup: string | null;
    /** Megjegyzés1 */
    remark1: string | null;
    /** Megjegyzés2 */
    remark2: string | null;
}

export const IfaceSyncInvoiceItemDefaultProps: IfaceSyncInvoiceItem = {
    id: 1,
    extCode: '',
    interface: 1,
    syncStatus: 1,
    errorText: null,
    syncRemark: null,
    userModified: false,
    insDate: new Date(),
    insTime: new Date(),
    insUserId: 1,
    updDate: new Date(),
    updTime: new Date(),
    updUserId: 1,
    head: 1,
    invNo: null,
    intItemId: 1,
    itemName: null,
    invRectify: null,
    rectVatDate: null,
    invStorno: null,
    dpaymIncInvId: null,
    dpaymIncInvNo: null,
    tax: null,
    unitPrice: null,
    currUnitPrice: null,
    discountPrice: null,
    currDiscountPrice: null,
    quantity: null,
    unitType: null,
    netto: null,
    total: null,
    vat: null,
    currNetto: null,
    currTotal: null,
    currVat: null,
    elabeAmount: null,
    car: null,
    prcar: null,
    stock: null,
    isParts: false,
    partsType: null,
    parts: null,
    gparts: null,
    accGroupCode: null,
    accCodeT: null,
    accCodeK: null,
    expAccGroupCode: null,
    expAccCodeT: null,
    expAccCodeK: null,
    vatAccCodeT: null,
    vatAccCodeK: null,
    vatCalcTypeCode: null,
    busPostGroup: null,
    prodPostGroup: null,
    vatBusPostGroup: null,
    vatProdPostGroup: null,
    remark1: null,
    remark2: null,
}
